export default __webpack_public_path__ + "assets/Hot Giggity Live.9c4c7b2d.png";